exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accountPage-main{width:100%;padding:16px 0px 48px 0px;margin:0px 0px 32px 0px}.accountPage-titleContainer{display:flex;justify-content:center;width:70%;margin:0 auto}\n", ""]);

// exports
